// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {buildNumber} from '../../../shared/services/build-number';

const getStatusClassName = days => {

    if (days <= 2) {

        return 'dot-icon-red';

    } else if (days > 2 && days <= 6) {

        return 'dot-icon-yellow';

    }

    return '';

};

const checkShipmentPriority = (days, isShipmentPriorityHigh) =>
    isShipmentPriorityHigh ? 'dot-icon-red' : getStatusClassName(days);

const PartReturnStatus = props => {

    const statusClassName = checkShipmentPriority(props.daysLeft, props.isShipmentPriorityHigh);

    return (
        <div className='part-return-status'>
            <span className={statusClassName}/>
            <FormattedMessage
                id='DAYS_LEFT_WITH_COUNT'
                values={{
                    days: props.daysLeft,
                    daysToDisplay: buildNumber(props.daysLeft)
                }}
            />
        </div>
    );

};

PartReturnStatus.displayName = 'PartReturnStatus';
PartReturnStatus.propTypes = {
    daysLeft: PropTypes.number.isRequired,
    isShipmentPriorityHigh: PropTypes.bool.isRequired
};

export default PartReturnStatus;



// WEBPACK FOOTER //
// ./src/part-requests/shared/components/part-return-status.js